import { createContext } from 'react';
import useGameLoopContext from './useGameLoopContext.hook';

export const GameLoopContext = createContext(null);
export function GameLoopContextProvider({
  children,
  fps,
  gameConf,
  initialState,
  prepareGameData,
}) {
  const { state, actions } = useGameLoopContext({
    fps,
    gameConf,
    initialState,
    prepareGameData,
  });
  return (
    <GameLoopContext.Provider value={{ state, actions }}>
      {children}
    </GameLoopContext.Provider>
  );
}
// https://codesandbox.io/s/fps-counter-forked-4oior0?file=/src/LoopContext.jsx:0-1457
